module.exports = __webpack_public_path__ + "img/SDAAIntroImage.6aaa8737.png";